import { SITE, } from '../consts';

export default function initSocial() {
  const fbBtns = document.getElementsByClassName('jsFbShare');
  const twitterBtns = document.getElementsByClassName('jsTwitterShare');
  let twitterHandle = 'haaretz';

  switch (SITE) {
    case 'haaretz.com':
      twitterHandle = 'haaretzcom';
      break;
    case 'themarker.com':
      twitterHandle = 'TheMarker';
      break;
    default:
      twitterHandle = 'haaretz';
      break;
  }

  const url = document.querySelector('link[rel="canonical"]')
    ? encodeURIComponent(
      document.querySelector('link[rel="canonical"]').getAttribute('href')
    )
    : null;
  const title = document.querySelector('meta[property="og:title"]')
    ? encodeURIComponent(
      document
        .querySelector('meta[property="og:title"]')
        .getAttribute('content')
    )
    : null;

  [ ...fbBtns, ].forEach(btn => {
    btn.addEventListener('click', () => {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        'facebook-share-dialog',
        'width=800,height=600'
      );
    });
  });
  [ ...twitterBtns, ].forEach(btn => {
    btn.addEventListener('click', () => {
      window.open(
        `https://twitter.com/intent/tweet?url=${url}&text=${title}&via=${twitterHandle}`,
        'twitter-share-dialog',
        'width=800,height=600'
      );
    });
  });
}
